import logger from 'utility/logger'

const BASE_KEY = 'proptax'

export const loadState = (key) => {
	const stateKey = BASE_KEY + key

	if (typeof window === 'undefined') return undefined

	const serializedState = localStorage.getItem(stateKey.toString())
	if (!serializedState || serializedState === 'undefined') return undefined

	logger.default(
		`Confirming load of state with key: ${stateKey}. Current loaded state: `,
		serializedState,
	)

	try {
		return JSON.parse(serializedState)
	} catch (err) {
		logger.default(`Failed to parse stored state for key: ${stateKey}`, err)
		return undefined
	}
}

export const saveState = (key, state) => {
	const stateKey = BASE_KEY + key

	if (typeof window === 'undefined') return undefined

	// JSON.stringify(undefined) is undefined, which localStorage.setItem would
	// coerce to the string "undefined" — poisoning the key. Remove it instead.
	if (state === undefined) {
		localStorage.removeItem(stateKey)
		return undefined
	}

	const serializedState = JSON.stringify(state)
	localStorage.setItem(stateKey, serializedState)
	const savedState = loadState(key)
	logger.default(
		`Confirming save of state with key: ${stateKey}. Current saved state: `,
		JSON.stringify(savedState),
	)
}
